const constant = {
  filterLast: [
    {
      key: -1,
      label: "All",
      value: "lastAll",
    },
    {
      key: 1,
      label: "Last 20",
      value: "last20",
    },
    {
      key: 2,
      label: "Last 100",
      value: "last100",
    },
    {
      key: 3,
      label: "Last 250",
      value: "last250",
    },
    {
      key: 4,
      label: "Last 500",
      value: "last500",
    },
  ],

  claimStateColor: {
    12: {
      stateid: 12,
      statename: "Submitted",
      statetype: "claim",
    },
    13: {
      stateid: 13,
      statename: "Accepted",
      statetype: "claim",
    },
    14: {
      stateid: 14,
      statename: "Paid",
      statetype: "claim",
      clr: "green",
    },
    16: {
      stateid: 16,
      statename: "Awaiting Dealer Response",
      statetype: "claim",
    },
    17: {
      stateid: 17,
      statename: "Awaiting Account Manager Response",
      statetype: "claim",
      clr: "red",
    },
    15: {
      stateid: 15,
      statename: "Awaiting Documents",
      statetype: "claim",
      clr: "orange",
    },
    19: {
      stateid: 19,
      statename: "Awaiting Parts",
      statetype: "claim",
      clr: "purple",
    },
    20: {
      stateid: 20,
      statename: "Dealer Self Repairing",
      statetype: "claim",
    },
    21: {
      stateid: 21,
      statename: "Supply Parts Only",
      statetype: "claim",
    },
    22: {
      stateid: 22,
      statename: "Labour Only",
      statetype: "claim",
    },
    23: {
      stateid: 23,
      statename: "Contribution Agreed",
      statetype: "claim",
    },
    24: {
      stateid: 24,
      statename: "Rejected",
      statetype: "claim",
      clr: "gray",
    },
    25: {
      stateid: 25,
      statename: "Awaiting Admin Response",
      statetype: "claim",
      clr: "blue",
    },
    29: {
      stateid: 29,
      statename: "Ready for Payment",
      statetype: "claim",
    },
    28: {
      stateid: 28,
      statename: "Ready for Payment",
      statetype: "invoice",
    },
    27: {
      stateid: 27,
      statename: "Account Manager Responded",
      statetype: "claim",
    },
    18: {
      stateid: 18,
      statename: "Awaiting Diagnosis",
      statetype: "claim",
      clr: "yellow",
    },
    30: {
      stateid: 30,
      statename: "Customer Notified by SMS",
      statetype: "claim",
    },
  },

  personTitles: [
    {
      key: "Mr",
      label: "Mr",
      value: "Mr",
    },
    {
      key: "Ms",
      label: "Ms",
      value: "Ms",
    },
    {
      key: "Mrs",
      label: "Mrs",
      value: "Mrs",
    },
    {
      key: "Miss",
      label: "Miss",
      value: "Miss",
    },
  ],

  notifyList: [
    {
      key: "account_manager",
      label: "Account Manager",
      value: "account_manager",
    },
    {
      key: "office",
      label: "Office",
      value: "office",
    },
    {
      key: "customer",
      label: "Customer",
      value: "customer",
    },
  ],

  claimsPrintBtnList: [
    {
      key: "claimpdf",
      label: "Claim PDF",
      value: "claimpdf",
    },
    {
      key: "policypdf",
      label: "Policy PDF",
      value: "policypdf",
    },
  ],

  daysDD: [
    { id: 1, label: "Sunday", key: "Sunday", value: "Sunday" },
    { id: 2, label: "Monday", key: "Monday", value: "Monday" },
    { id: 3, label: "Tuesday", key: "Tuesday", value: "Tuesday" },
    { id: 4, label: "Wednesday", key: "Wednesday", value: "Wednesday" },
    { id: 5, label: "Thursday", key: "Thursday", value: "Thursday" },
    { id: 6, label: "Friday", key: "Friday", value: "Friday" },
    { id: 7, label: "Saturday", key: "Saturday", value: "Saturday" },
  ],

  timesDD: [
    { id: 0, label: "00", key: "00", value: "00" },
    { id: 1, label: "01", key: "01", value: "01" },
    { id: 2, label: "02", key: "02", value: "02" },
    { id: 3, label: "03", key: "03", value: "03" },
    { id: 4, label: "04", key: "04", value: "04" },
    { id: 5, label: "05", key: "05", value: "05" },
    { id: 6, label: "06", key: "06", value: "06" },
    { id: 7, label: "07", key: "07", value: "07" },
    { id: 8, label: "08", key: "08", value: "08" },
    { id: 9, label: "09", key: "09", value: "09" },
    { id: 10, label: "10", key: "10", value: "10" },
    { id: 11, label: "11", key: "11", value: "11" },
    { id: 12, label: "12", key: "12", value: "12" },
    { id: 13, label: "13", key: "13", value: "13" },
    { id: 14, label: "14", key: "14", value: "14" },
    { id: 15, label: "15", key: "15", value: "15" },
    { id: 16, label: "16", key: "16", value: "16" },
    { id: 17, label: "17", key: "17", value: "17" },
    { id: 18, label: "18", key: "18", value: "18" },
    { id: 19, label: "19", key: "19", value: "19" },
    { id: 20, label: "20", key: "20", value: "20" },
    { id: 21, label: "21", key: "21", value: "21" },
    { id: 22, label: "22", key: "22", value: "22" },
    { id: 23, label: "23", key: "23", value: "23" },
  ],

  processDD: [{ label: "Invoices", key: "Invoices", value: "Invoices" }],

  repeatDD: [
    // in repeat dropdown
    { label: "None", key: "Every Hour", value: "Every Hour" },
    { label: "Every Hour", key: "Every Hour", value: "Every Hour" },
    { label: "Every Day", key: "Every Day", value: "Every Day" },
    { label: "Every Week", key: "Every Week", value: "Every Week" },
    { label: "Every Month", key: "Every Month", value: "Every Month" },
  ],

  refundDD: [
    // in repeat dropdown
    { label: "No Refund", key: "No Refund", value: "No Refund", refundid: 0 },
    { label: "On Expire", key: "On Expire", value: "On Expire", refundid: 4 },
    { label: "On Sale", key: "On Sale", value: "On Sale", refundid: 5 },
    { label: "After", key: "After", value: "After", refundid: 6 },
    { label: "Daily", key: "Daily", value: "Daily", refundid: 1 },
    { label: "Weekly", key: "Weekly", value: "Weekly", refundid: 2 },
    { label: "Monthly", key: "Monthly", value: "Monthly", refundid: 3 },
  ],

  pricingrefunddurationDD: [
    { label: "Days", key: "Days", value: "Days" },
    { label: "Weeks", key: "Weeks", value: "Weeks" },
    { label: "Months", key: "Months", value: "Months" },
    { label: "Years", key: "Years", value: "Years" },
    { label: "Lifetime", key: "Lifetime", value: "Lifetime" },
  ],

  auAdminChargesDD: [
    { label: "None", key: "None", value: "None", id: 0 },
    { label: "Percentage", key: "Percentage", value: "Percentage", id: 1 },
    {
      label: "Fixed Amount",
      key: "Fixed Amount",
      value: "Fixed Amount",
      id: 2,
    },
  ],

  defaultCommRuleDD: [
    {
      label: "No Commission",
      key: "No Commission",
      value: "No Commission",
      id: 0,
    },
    { label: "Percentage", key: "Percentage", value: "Percentage", id: 1 },
    {
      label: "Amount",
      key: "Amount",
      value: "Amount",
      id: 2,
    },
  ],

  defaultCommRulePaidDD: [
    {
      label: "Product Expires",
      key: "Product Expires",
      value: "Product Expires",
      id: 2,
    },
    {
      label: "Product Sold",
      key: "Product Sold",
      value: "Product Sold",
      id: 3,
    },
    {
      label: "Product Invoiced",
      key: "Product Invoiced",
      value: "Product Invoiced",
      id: 1,
    },
    {
      label: "Invoice Paid",
      key: "Invoice Paid",
      value: "Invoice Paid",
      id: 0,
    },
  ],

  states: [
    { stateid: 1, statename: "None", statetype: "policy" },
    { stateid: 2, statename: "Quote", statetype: "policy" },
    { stateid: 3, statename: "Saved", statetype: "policy" },
    { stateid: 4, statename: "Posted", statetype: "policy" },
    { stateid: 5, statename: "Cancelled", statetype: "policy" },
    { stateid: 6, statename: "Deleted", statetype: "policy" },
    { stateid: 7, statename: "Req: Cancel", statetype: "policy" },
    { stateid: 8, statename: "Req: Modify", statetype: "policy" },
    { stateid: 9, statename: "Pending", statetype: "invoice" },
    { stateid: 10, statename: "Paid", statetype: "invoice" },
    { stateid: 11, statename: "Invoiced", statetype: "policy" },
    { stateid: 12, statename: "Submitted", statetype: "claim" },
    { stateid: 13, statename: "Accepted", statetype: "claim" },
    { stateid: 14, statename: "Paid", statetype: "claim" },
    { stateid: 15, statename: "Awaiting Documents", statetype: "claim" },
    { stateid: 16, statename: "Awaiting Dealer Response", statetype: "claim" },
    {
      stateid: 17,
      statename: "Awaiting Account Manager Response",
      statetype: "claim",
    },
    { stateid: 18, statename: "Awaiting Diagnosis", statetype: "claim" },
    { stateid: 19, statename: "Awaiting Parts", statetype: "claim" },
    { stateid: 20, statename: "Dealer Self Repairing", statetype: "claim" },
    { stateid: 21, statename: "Supply Parts Only", statetype: "claim" },
    { stateid: 22, statename: "Labour Only", statetype: "claim" },
    { stateid: 23, statename: "Contribution Agreed", statetype: "claim" },
    { stateid: 24, statename: "Rejected", statetype: "claim" },
    { stateid: 25, statename: "Awaiting Admin Response", statetype: "claim" },
    { stateid: 27, statename: "Account Manager Responded", statetype: "claim" },
    { stateid: 28, statename: "Ready for Payment", statetype: "invoice" },
    { stateid: 29, statename: "Ready for Payment", statetype: "claim" },
    { stateid: 30, statename: "Customer Notified by SMS", statetype: "claim" },
  ],

  statesObj: {
    1: { stateid: 1, statename: "None", statetype: "policy" },
    2: { stateid: 2, statename: "Quote", statetype: "policy" },
    3: { stateid: 3, statename: "Saved", statetype: "policy" },
    4: { stateid: 4, statename: "Posted", statetype: "policy" },
    5: { stateid: 5, statename: "Cancelled", statetype: "policy" },
    6: { stateid: 6, statename: "Deleted", statetype: "policy" },
    7: { stateid: 7, statename: "Req: Cancel", statetype: "policy" },
    8: { stateid: 8, statename: "Req: Modify", statetype: "policy" },
    9: { stateid: 9, statename: "Pending", statetype: "invoice" },
    10: { stateid: 10, statename: "Paid", statetype: "invoice" },
    11: { stateid: 11, statename: "Invoiced", statetype: "policy" },
    12: { stateid: 12, statename: "Submitted", statetype: "claim" },
    13: { stateid: 13, statename: "Accepted", statetype: "claim" },
    14: { stateid: 14, statename: "Paid", statetype: "claim" },
    15: { stateid: 15, statename: "Awaiting Documents", statetype: "claim" },
    16: {
      stateid: 16,
      statename: "Awaiting Dealer Response",
      statetype: "claim",
    },
    17: {
      stateid: 17,
      statename: "Awaiting Account Manager Response",
      statetype: "claim",
    },
    18: { stateid: 18, statename: "Awaiting Diagnosis", statetype: "claim" },
    19: { stateid: 19, statename: "Awaiting Parts", statetype: "claim" },
    20: { stateid: 20, statename: "Dealer Self Repairing", statetype: "claim" },
    21: { stateid: 21, statename: "Supply Parts Only", statetype: "claim" },
    22: { stateid: 22, statename: "Labour Only", statetype: "claim" },
    23: { stateid: 23, statename: "Contribution Agreed", statetype: "claim" },
    24: { stateid: 24, statename: "Rejected", statetype: "claim" },
    25: {
      stateid: 25,
      statename: "Awaiting Admin Response",
      statetype: "claim",
    },
    27: {
      stateid: 27,
      statename: "Account Manager Responded",
      statetype: "claim",
    },
    28: { stateid: 28, statename: "Ready for Payment", statetype: "invoice" },
    29: { stateid: 29, statename: "Ready for Payment", statetype: "claim" },
    30: {
      stateid: 30,
      statename: "Customer Notified by SMS",
      statetype: "claim",
    },
  },
  
  userCustom: {
    440: {
      brandlogo: "./img/img-brand-logo-440.jpg",
      footer: "Office: 0161 696 9579 / claims@protectmymotor.com",
    },
    "-1": {
      brandlogo: "./img/img-brand-logo-dark.png",
      footer: "Office: 01244 378 544 / admin@auwarranties.co.uk"
    },
  },
};

export default constant;
